/*
	jQuery function jSetupDynamicTables
		-	Applies dynamic editing functionality to a table combination.

		Array options 	- form: String/Object - form attached to the table.
												defaults to the data-form="" parameter on the table.
						- save_select: String/Object - save button within the form.
						- add_select: String/Object - add button within the table.
						- cancel_select: String/Object - cancel button within the form.
						- form_title_toggle_select: String/Object - form title toggle which shows Add/Edit.
						- hide_edit_select: String/Object - elements which must be hidden only when editing.
						- hide_add_select: String/Object - elements which must be hidden only when adding.
						- read_only: String - jQuery selector String for read only elements

		Classes 		- ignore: apply to table row and form field to identify content which should never be updated
								  but needs to be displayed.
						- [select[name]]_used: Secondary selector class with all used elements in a limited select
											   to allow selection of used elements.
*/

(function($){
	$.fn.jSetupDynamicTables = function(options){
		if (this.length > 0) {
			var defaults = {
				'form' : this.data('form'),
				'save_select' : '.btnGreen.saveBtn',
				'add_select' : '.dfAddBtn-js',
				'cancel_select' : '.cancelBtn',
				'form_title_toggle_select' : '.add-edit-toggle',
				'diable_edit' : '.disable-edit',
				'hide_edit_select' : '.hide-edit',
				'hide_add_select' : '.hide-add',
				'read_only' : '.read-only',
				'ignore_tags' : ['input', 'button', 'select', 'a'],
				'ignore_classes' : ['sortableHandle'],
				'save_text' : 'Save',
				'add_text' : 'Create',
				'edit_text' : 'Edit',
				'edit_function' : function(){},
				'finish' : function(){}
			};

			// saving selects for reuse.
			var parameters = $.extend(defaults, options);
			parameters.table = this;
			//If no form selector passed, just get closest form.
			if(typeof parameters.form !== 'undefined' && parameters.form.trim() != '') {
				parameters.form = $(parameters.form);
			} else {
				var currentSelect = $(this);
				while (currentSelect != $(this).closest('body')) {
					parameters.form = currentSelect.parent().find('form');
					parameters.form = (parameters.form.length > 1) ? $(parameters.form[0]) : parameters.form ;
					currentSelect = currentSelect.parent();
					if (parameters.form.length > 0) break;
				}
			}

			parameters.add = $(parameters.add_select, document);
			parameters.cancel = $(parameters.cancel_select, parameters.form);
			parameters.title = $(parameters.form_title_toggle_select, parameters.form);
			parameters.saveBtn = $(parameters.save_select, parameters.form);
			parameters.hideEdit = $(parameters.hide_edit_select);
			parameters.hideAdd = $(parameters.hide_add_select);
			parameters.diableEdit = $(parameters.diable_edit);

			return this.each(function(){
				// Unfortunately due to ajax, we need to use .on(), and it doesn't allow passing anything but a selection string
				// This function allows us to have multiple tables and forms on 1 page.
				var buildButtonSelect = function (getparent, getbranch, getroot) {
					var branch = $(getparent);
					var tree = branch.parentsUntil(getroot);
					var root = $(getroot);
					var select = getbranch;

					for (var i = 0; i < tree.length; i++) {
						var currentSelect = branch.prop("tagName").toLowerCase();

						if (branch.prop('id').length > 0) {
							currentSelect += '#' + branch.prop('id');
						} else if (branch.prop('class').length > 0) {
							currentSelect += '.' + branch.prop('class').split(' ').join('.');
						}

						select = currentSelect + ' ' + select;
						branch = $(tree[i]);
					}

					return (select != '') ? select : false;
				}
                var tableButton = buildButtonSelect(parameters.table, 'tbody tr:not(.read-only, .ignore)', document);
                var addSelectButton = buildButtonSelect(document, parameters.add_select, document);
                var cancelSelectButton = buildButtonSelect(parameters.form, parameters.cancel_select, document);
				$(document).off('click', tableButton).on('click', tableButton, function(e) {
					var ignore = false;

					for (var i in parameters.ignore_classes) {
						ignore =  (ignore || $(e.target).hasClass(parameters.ignore_classes[i])) ? true : false;
					}

					var hasTag = ($(e.target).children(parameters.ignore_tags.toString()).length > 0);

					if (parameters.ignore_tags.indexOf(e.target.tagName.toLowerCase()) < 0 && !hasTag && !ignore) {
						var row = $(this);
						var dataArr = row.data();
						elementIgnore = row.hasClass('ignore');

						for (var id in dataArr) {
							formField = $('input[name], select[name], textarea', parameters.form).filter(function() {
								return (
										(this.id.toLowerCase() == id)
								||
										(typeof this.name !== 'undefined' && (this.name.toLowerCase() == id || this.name.toLowerCase() == id+'[]'))

							); });

							$(formField).each(function() {
								if (elementIgnore && $(this).hasClass('ignore')) {
									row.prop('disabled', true);
								} else if (!elementIgnore && $(this).hasClass('ignore')) {
									row.prop('disabled', false);
								}
								if (this.type == "checkbox") {
									$(this).prop('checked', dataArr[id] == '1');
								} else if (this.type == "radio") {
									if ($(this).val() == dataArr[id]) {
										$(this).prop('checked', true);
									}
								} else if (this.tagName.toLowerCase() == 'textarea') {
									this.innerText = dataArr[id];
								} else if (this.tagName.toLowerCase() == 'select') {
									var select = $(this);
									//This handles suggestSelects and suggestSelects which filter used results.
									var used = $('.' + this.name + '_used', parameters.form);
									var selector = 'option[value="'+dataArr[id]+'"], option[value="'+parseFloat(dataArr[id])+'"]';

									if (used.exists()) {
										usedRow = $(selector, used);
										select.prepend(usedRow.clone());
										var created = $(selector, this);
										created.prop('selected', true);
										select.next('.suggestselectButton').find('.label').html(created.html());
									} else {
										$(selector, this).prop('selected', true);
										select.next('.suggestselectButton').find('.label').html($(selector, this).html());
									}
								} else {
									this.value = dataArr[id];
								}
							});
						}

						parameters.saveBtn.html(parameters.save_text);
						parameters.saveBtn.attr('params', parameters.form.data('edit'));
						parameters.saveBtn.attr('data-cy',"Save");
						parameters.title.html('<span class="icon-edit"></span> ' + parameters.edit_text);
						parameters.form.show();
						parameters.table.hide();
						parameters.hideAdd.show();
						parameters.hideEdit.hide();
						parameters.diableEdit.prop('disabled', true);
						parameters.edit_function();
						parameters.finish();
						parameters.add.hide();
					}
				}).off('click', addSelectButton).on('click', addSelectButton, function(e) {
					var inputs = $('input, select', parameters.form);
					for (var i = 0; i < inputs.length; i++) {
                        if ($(inputs[i]).hasClass("suggestSelect")) {
                            $(inputs[i]).suggestselect("setValue", $(inputs[i]).data("default-value"));
                        } else if (inputs[i].type != "checkbox" && inputs[i].type != "radio") {
							$(inputs[i]).val($(inputs[i]).data("default-value"));
						} else {
							$(inputs[i]).prop("checked", $(inputs[i]).data("default-value"));
						}
						if (inputs[i].className == 'ignore') {
							$(inputs[i]).prop('disabled', false);
						}
					}
					parameters.saveBtn.html(parameters.add_text);
					parameters.saveBtn.attr('params', parameters.form.data('add'));
					parameters.saveBtn.attr('data-cy',"Create");
					parameters.title.html('<span class="icon-plus"></span> ' + parameters.add_text);
					parameters.form.show();
					parameters.table.hide();
					parameters.hideEdit.show();
					parameters.diableEdit.prop('disabled', false);
					parameters.hideAdd.hide();
					parameters.add.hide();
					if (inputs.exists) {
						$(inputs[0]).focus();
					}
					parameters.finish();
				}).off('click', cancelSelectButton).on('click', cancelSelectButton, function() {
					parameters.form.hide();
					parameters.table.show();
					parameters.hideEdit.show();
					parameters.diableEdit.prop('disabled', false);
					parameters.hideAdd.show();
					parameters.add.show();

					formField = $('select', parameters.form);

					$(formField).each(function() {
						var used = $('.' + this.name + '_used option');

						for (var i = 0; i < used.length; i++) {
							$('option[value="'+$(used[i]).val()+'"]', this).remove();
						}

						$('option:eq(0)', this).prop('selected', true);
						$(this).next('.suggestselectButton').find('.label').html($('option:eq(0)', this).html());
					});
				});
			});
		}
	};
})(jQuery);